// Module
var code = `<div class="group/tooltip-hover relative"> <div class="" ng-transclude></div> <span ng-class="{
    'left-1/2 -translate-x-1/2' : \$ctrl.position == 'bottom' || \$ctrl.position == 'top',
    'top-full' : \$ctrl.position == 'bottom',
    'bottom-full' : \$ctrl.position == 'top',
    'top-1/2 -translate-y-1/2': \$ctrl.position == 'right' || \$ctrl.position == 'left',
    'left-full translate-x-3' : \$ctrl.position == 'right',
    'right-full -translate-x-3' : \$ctrl.position == 'left'
    }" class="invisible absolute z-99 mb-1 capitalize scale-75 rounded-lg bg-gray-700/80 py-1 px-2 w-max max-w-[300px] text-balance text-center text-xs text-white opacity-0 transition-all duration-200 group-hover/tooltip-hover:visible! group-hover/tooltip-hover:scale-100 group-hover/tooltip-hover:opacity-100">{{ \$ctrl.tooltip }}</span> </div>`;
// Exports
export default code;